"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseColors = {
    transparent: 'transparent',
    neutral: {
        colorWhite: '#fff',
        colorLight: '#ddd',
        colorLightest: '#fafafa',
        colorMedium: '#a2a2a2',
        colorDark: '#3c3c3c',
        colorDarkest: '#161616',
    },
    brandcolor: {
        primaryLightest: '#90CCFF',
        primaryLight: '#4094d9',
        primaryMedium: '#0071ce',
        primaryDark: '#00386b',
        primaryDarker: '#08213F',
        primaryDarkest: '#041223',
        secondaryLightest: '#ffb790',
        secondaryMedium: '#f65e0a',
        secondaryDark: '#D43809',
        secondaryDarkest: '#A72800',
    },
    feedbackSuccess: {
        colorLightest: '#CFE6CF',
        colorLight: '#4ABF2F',
        colorMedium: '#059203',
        colorDark: '#026F00',
    },
    feedbackError: {
        colorLightest: '#F5A3A2',
        colorLight: '#EC5B59',
        colorMedium: '#CE0400',
        colorDark: '#9D0300',
    },
    feedbackWarning: {
        colorMedium: '#F8B508',
    },
};
exports.default = baseColors;
//# sourceMappingURL=baseColors.js.map